import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, MANTINE_SIZES, getSize } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
function getGutterStyles(gutters, theme) {
  return MANTINE_SIZES.reduce(function (acc, size) {
    if (typeof gutters[size] !== "undefined") {
      acc["@media (min-width: ".concat(theme.breakpoints[size], ")")] = {
        margin: "calc(-".concat(getSize({
          size: gutters[size],
          sizes: theme.spacing
        }), " / 2)")
      };
    }
    return acc;
  }, {});
}
var useStyles = createStyles(function (theme, _ref) {
  var justify = _ref.justify,
    align = _ref.align,
    gutter = _ref.gutter,
    gutterXs = _ref.gutterXs,
    gutterSm = _ref.gutterSm,
    gutterMd = _ref.gutterMd,
    gutterLg = _ref.gutterLg,
    gutterXl = _ref.gutterXl;
  return {
    root: __spreadValues({
      margin: "calc(-".concat(getSize({
        size: gutter,
        sizes: theme.spacing
      }), " / 2)"),
      display: "flex",
      flexWrap: "wrap",
      justifyContent: justify,
      alignItems: align
    }, getGutterStyles({
      xs: gutterXs,
      sm: gutterSm,
      md: gutterMd,
      lg: gutterLg,
      xl: gutterXl
    }, theme))
  };
});
export default useStyles;